






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class ProductContainerCombobox extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  // @Prop({ type: String }) schema!: string;
  // @Prop({ type: Array }) data!: any[];
  // @Prop({ type: String }) keyField!: string;
  // @Prop({ type: String }) labelField!: string;
  // @Prop({ type: String }) relField!: string;

  @Prop({ type: String }) productFilter!: string;

  @Prop({ type: String }) clientId!: string;

  @Prop({ type: String }) position!: string;
  @Prop({ type: Boolean }) multiple!: boolean;

  @Prop({ type: String }) placeholder!: string;
  @Prop({ type: String }) disabled!: boolean;
  @Prop({ type: String }) withArchived!: boolean;
  @Prop({ type: Boolean, default: false }) clearable!: boolean;
  @Prop({ type: Boolean }) wrap!: boolean;

  localValue: any = null
  selectdItemLabel: any = '';
  dropdownActive = false;

  items: any[] = [];
  itemsForDisplay: any[] = [];

  searchText: string = '';

  public created() {
    // 
  }

  public mounted() {
    this.selectdItemLabel = this.placeholder;

    // if (this.schema) {
      this.loadData();
    // } else {
    //   this.items = this.data;
    //   this.onValueChange(this.value);
    //   this.updateDisplayList();
    // }
  }
// schema="products" key-field="id" label-field="name"
  public loadData() {
    const QNAME = `SELECT_COMBOBOX_LIST_PRODUCT_VARIANTS`;
    const productFilter =
      this.productFilter != null && this.productFilter !== ""
        ? this.productFilter
        : null;
    const clientId =
      this.clientId != null && this.clientId !== "" ? this.clientId : null;

    if (!productFilter) {
      if (process.env.NODE_ENV === "development") {
        console.debug(
          "[ProductContainerCombobox.loadData] skip: empty productFilter",
          { clientId, value: this.value },
        );
      }
      this.items = [];
      this.onValueChange(this.multiple && !Array.isArray(this.value) ? [this.value] : this.value);
      this.updateDisplayList();
      return;
    }

    if (process.env.NODE_ENV === "development") {
      console.debug("[ProductContainerCombobox.loadData] START", {
        productFilter,
        clientId,
        withArchived: this.withArchived,
      });
    }

    this.$db([
      this.$q(QNAME)
        .raw('documents.list')
        .action({
          columns: {
            id: 'product_container.id',
            product_id: 'product_container.product_id',
            label: 'product_container.name',
            position: 'product_container.position',
            weight: 'product_container.weight',
            volume: 'product_container.volume',
            is_sample: 'product_container.is_sample',
            // price: 'product_container.price',
            price_per_kg: 'product_container.price_per_kg',
            price: 'personal_settings.container_price',
            client_product_container_id: 'personal_settings.id'
          },
  
          from: 's:product_containers',
          from_as: 'product_container',
          joins: [
            {
              join: 's:products',
              type: 'left',
              as:   'products',
              on: { $eq: ['products.id', 'product_container.product_id'] }
            },
            {
              join: 's:client_product_containers',
              type: 'left',
              as:   'personal_settings',
              on: {
                $and: [
                  { $eq: ['personal_settings.product_container_id', 'product_container.id'] },
                  ...(clientId
                    ? [{ $eq: ['personal_settings.client_id', { $: clientId }] }]
                    : []),
                ]
              }
            }
          ],
          order: [
            {$asc: ['product_container.name']}
          ],
          where: {
            $and: [
              { $eq: ['products.id', { $: productFilter }] },
              {
                $or: [
                  {
                    $and: [
                      ...(clientId
                        ? [{ $eq: ['personal_settings.client_id', { $: clientId }] }]
                        : []),
                      // 
                      ...(!this.withArchived ? [{ $null: [ 'products.archived_at' ] }] : []),
                      ...(!this.withArchived ? [{ $null: [ 'product_container.archived_at' ] }] : []),
                      ...(!this.withArchived ? [{ $eq: ['personal_settings.hidden', {$: false}] }] : []),
                    ]
                  },
                  {
                    $and: [
                      { $eq: ['product_container.is_sample', {$: true}] },
                      // 
                      ...(!this.withArchived ? [{ $null: [ 'products.archived_at' ] }] : []),
                      ...(!this.withArchived ? [{ $null: [ 'product_container.archived_at' ] }] : []),
                    ]
                  },
                  ...(this.value ? [
                    { $eq: ['product_container.id', {$: this.value}] },
                  ] : [])
                ]
              },
            ]
          },
          page_size: 1000
        })
      // .where((_: any) => {
      //   if(this.relField) {
      //     return _.eq(`product_containers.${this.relField}`, _.const(this.relFilter));
      //   } else {
      //     return undefined;
      //   }
      // })
      // .limit(1000),
    ]).then(((result: ServerResult) => {
      this.items = result.getOperation(QNAME).getContent().documents;

      if(this.multiple && !Array.isArray(this.value)) {
        this.onValueChange([this.value]);
      } else {
        this.onValueChange(this.value);
      }
      this.updateDisplayList()
      if (process.env.NODE_ENV === "development") {
        console.debug("[ProductContainerCombobox.loadData] DONE", {
          count: this.items && this.items.length,
        });
      }
    })).catch((error) => {
      const e = error as any;
      console.error("[ProductContainerCombobox.loadData] ERROR", {
        message: e && e.message,
        productFilter,
        clientId,
      });
    });
  }

  @Watch('value')
  onValueChange(newVal: any) {
    // console.log(newVal);
    this.localValue = newVal;

    if (this.localValue) {
      if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        if (selectdItems.length > 0) {
          this.selectdItemLabel = selectdItems.map(item => item.label).join(', ');
        } else {
          this.selectdItemLabel = ''
        }

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        if (selectdItem) {
          this.selectdItemLabel = selectdItem.label;
        } else {
          this.selectdItemLabel = ''
        }
      }
    } else {
      this.selectdItemLabel = ''
    }
  }

  @Watch('productFilter')
  onRelFilterChange(newVal: any) {
    console.log('onRelFilterChange');
    this.updateValue(null);
    this.loadData();
  }

  clear() {
    this.updateValue(null);
  }

  updateValue(value: any) {
    this.onValueChange(value);
    this.$emit('input', value);

    if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        this.$emit('input-object', selectdItems);

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        this.$emit('input-object', selectdItem);
      }
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
    const width = this.$el.clientWidth;
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].style.width = width + 'px';
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].children[0].style.width = (width - 25) + 'px';
    console.log('this.dropdownActive', this.dropdownActive, this.$refs.searchInput);
    if (this.dropdownActive) {
      (this.$refs.searchInput as any).focus()
    }
  }

  @Watch('searchText')
  updateDisplayList() {
    this.$set(this, 'itemsForDisplay', (this.items || []).filter((item: any) => {
      return item.label.toLowerCase().includes(this.searchText);
    }))
  }

  // search($event) {
  //   throttle
  // }
}
